module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_shisyu-5b575fcaef7789c6bb6ec08495e36874.png";